import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { FormHeader } from '../../../components/typography/PopoverTypography';
import { ConfirmButton } from '../../../components/buttons/popoverButtons';
import EmailInputField from '../../../components/inputs/EmailInputField';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 320px;
`;

interface Props {
  value: string;
  onConfirmPress: (value: string) => void;
}

const UpdateEmailForm = ({ value, onConfirmPress }: Props) => {
  const { t } = useTranslation('users');
  const [userEmail, setUserEmail] = useState(value);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onConfirmPress(userEmail);
    }
  };

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <FormContainer onKeyDown={handleKeyPress}>
      <FormHeader>{t('update-email-address.header')}</FormHeader>
      <EmailInputField
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUserEmail(e.target.value)}
        value={userEmail}
      />
      <ConfirmButton
        label={t('update-email-address.confirm-btn')}
        onClick={() => onConfirmPress(userEmail)}
        disabled={!isValidEmail(userEmail) || value === userEmail}
      />
    </FormContainer>
  );
};

export default UpdateEmailForm;
